import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-check-out',
  templateUrl: './check-out.component.html',
  styleUrls: ['./check-out.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckOutComponent implements OnInit {
  checkoutStep:number = 2;
  totalAmt:number = 50000;
  slabPercent;
  payment;
  advAmt:Number;
  deliveryAmt:Number;
  constructor() { }

  ngOnInit() {
    this.slabPercent = [
        { value: '10', display: '10%' },
        { value: '20', display: '20%' },
        { value: '30', display: '30%' },
        { value: '40', display: '40%' },
        { value: '50', display: '50%' },
    ];
    this.payment = {
      slabPercent: this.slabPercent[0].value,
      shippingAddrOption: false
    }

    this.advAmt = ( parseInt(this.slabPercent[0].value) * ( this.totalAmt + 450 + 600 + 500 ) ) / 100;
    this.deliveryAmt = Number(this.totalAmt + 450 + 600 + 500) - Number(this.advAmt);
  }

  calcBifurgation(percent){
    this.advAmt = ( percent * (this.totalAmt + 450 + 600 + 500) ) / 100;
    this.deliveryAmt = Number(this.totalAmt + 450 + 600 + 500) - Number(this.advAmt);
  }
  
  goToPayment(){
    this.checkoutStep = 3;
  }

  goToDelivery(){
    this.checkoutStep = 2;
  }
}
